import { categories } from 'containers/admin/clients/client/tabs-components/goals-tab/goals-configuration/categories';
import type { GoalSchema } from 'containers/admin/clients/client/tabs-components/goals-tab/types';

export const Proportion: GoalSchema = {
  Proportion: {
    subType: null,
    valueType: 'PERCENT',
    categories,
  },
};
